import { render, staticRenderFns } from "./impersonate-logout.vue?vue&type=template&id=1f14ab99&"
import script from "./impersonate-logout.vue?vue&type=script&lang=js&"
export * from "./impersonate-logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports